// src/store/authReducer.js
import { italyFlag } from "@components/images";
import { createSlice } from "@reduxjs/toolkit";
import { USER_LOGOUT } from "@constants";
import APICaller from "@services/ApiRequest";

const storedUser = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
const lang = localStorage.getItem("language");
const flag = localStorage.getItem("flag");

export const initialState = {
  user: storedUser || null,
  isLoggedIn: !!storedUser,
  userData: JSON.parse(localStorage.getItem("userData")) || { userId: "" },
  languageToTranslate: lang || "it",
  flag: flag || italyFlag,
  isForcedSignOut: false,
  loading: false,
};

const { actions, reducer } = createSlice({
  name: "AUTH",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    login: (state, action) => {
      const { userId, user } = action.payload;

      localStorage.removeItem("consentModalDismiss");
      localStorage.setItem("user", JSON.stringify(user));

      state.isLoggedIn = true;
      state.user = user;
      state.userData.userId = userId;
      state.isForcedSignOut = false;

      localStorage.setItem("userData", JSON.stringify(state.userData));
    },

    logout: (state) => {
      localStorage.removeItem("consentModalDismiss");
      localStorage.removeItem("user");
      localStorage.removeItem("userData");

      state.isLoggedIn = false;
      state.user = null;
      state.userData = { userId: "" };
      state.isForcedSignOut = false;

      APICaller(USER_LOGOUT, null, { method: "DELETE" });
    },

    userUpdate: (state, action) => {
      const storedUser = JSON.parse(localStorage.getItem("user")) || {};
      const { confirmEmail, ...restElements } = action.payload.updatedUser;
      const finalUser = { ...storedUser, ...restElements };
      state.user = finalUser;
      localStorage.setItem("user", JSON.stringify(finalUser));
    },

    setLanguage: (state, action) => {
      localStorage.setItem("language", action.payload);
      state.languageToTranslate = action.payload;
    },

    setFlagToTop: (state, action) => {
      localStorage.setItem("flag", action.payload);
      state.flag = action.payload;
    },
  },
});

export const { login, logout, userUpdate, setLanguage, setFlagToTop, setLoading } = actions;
export default reducer;
